import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { statusEnum } from '../../helpers/constants';

@Component({
  selector: 'app-dialog-message-modal',
  templateUrl: './dialog-message-modal.component.html',
  styleUrls: ['./dialog-message-modal.component.sass'],
})
export class DialogMessageModalComponent implements OnInit {
  statusEnum = statusEnum;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}
}
